<div class="dx-field">
    <div class="dx-field-value">
        <dx-radio-group
            style="width: max-content;"
            [disabled]="disabled"
            [items]="billTo"
            [(value)]="selected"
            (onValueChanged)="valueChanged()"
            layout="horizontal"
        >
        </dx-radio-group>
    </div>
</div>
